import { ACORN_QUOTE_CATEGORIES } from "./acornQuoteData";

const CURRENCY_SYMBOLS = {
    GBP: "£",
    CNY: "¥",
    EUR: "€",
    USD: "$",
};

export function getAcornCurrencySymbol(currency) {
    return CURRENCY_SYMBOLS[currency] || currency;
}

export function formatAcornMoney(amount, currency) {
    const value = Number(amount);
    if (!Number.isFinite(value)) {
        return `${getAcornCurrencySymbol(currency)}0.00`;
    }

    const formatted = value.toLocaleString("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return `${getAcornCurrencySymbol(currency)}${formatted}`;
}

export function calcAcornLineSubtotal(unitPrice, quantity) {
    const price = parseFloat(unitPrice);
    const qty = parseFloat(quantity);

    if (!Number.isFinite(price) || !Number.isFinite(qty) || price < 0 || qty < 0) {
        return 0;
    }

    return price * qty;
}

export function formatAcornQuantity(quantity) {
    const value = parseFloat(quantity);
    if (!Number.isFinite(value)) {
        return "0";
    }

    return Number.isInteger(value) ? String(value) : String(value);
}

export function formatAcornQuoteDate(date) {
    if (!date) {
        return "";
    }

    return date.format("YYYY.MM.DD");
}

export function countAcornActiveLines(categories) {
    return ACORN_QUOTE_CATEGORIES.reduce((sum, key) => {
        const items = categories[key] || [];
        const active = items.filter((line) => String(line.name || "").trim());
        return sum + active.length;
    }, 0);
}

export function buildAcornQuoteDisplay(formState) {
    const categories = ACORN_QUOTE_CATEGORIES.map((key) => {
        const items = (formState.categories[key] || [])
            .filter((line) => String(line.name || "").trim())
            .map((line) => ({
                ...line,
                subtotal: calcAcornLineSubtotal(line.unitPrice, line.quantity),
            }));

        const subtotal = items.reduce((sum, item) => sum + item.subtotal, 0);

        return { key, items, subtotal };
    }).filter((category) => category.items.length > 0);

    const grandTotal = categories.reduce((sum, category) => sum + category.subtotal, 0);
    const totalLines = categories.reduce((sum, category) => sum + category.items.length, 0);
    const globalNotes = (formState.globalNotes || [])
        .map((note) => String(note || "").trim())
        .filter(Boolean);
    const projectName = String(formState.projectName || "").trim();

    return {
        projectName,
        quoteDateLabel: formState.quoteDate ? formatAcornQuoteDate(formState.quoteDate) : "",
        validUntilLabel: formState.validUntil ? formatAcornQuoteDate(formState.validUntil) : "",
        currency: formState.currency,
        portfolioUrl: String(formState.portfolioUrl || "").trim(),
        hideSubitemPrices: Boolean(formState.hideSubitemPrices),
        categories,
        grandTotal,
        totalLines,
        globalNotes,
    };
}

export function validateAcornQuoteForm(formState, t) {
    const projectName = String(formState.projectName || "").trim();
    if (!projectName) {
        return t("validation.projectNameRequired");
    }

    const portfolioUrl = String(formState.portfolioUrl || "").trim();
    if (portfolioUrl) {
        try {
            const parsed = new URL(portfolioUrl);
            if (!["http:", "https:"].includes(parsed.protocol)) {
                return t("validation.portfolioUrlInvalid");
            }
        } catch {
            return t("validation.portfolioUrlInvalid");
        }
    }

    return "";
}
